__turbopack_context__.v({
  "cell": "RiskSummaryWidget-module__zwk5Iq__cell",
  "cellLabel": "RiskSummaryWidget-module__zwk5Iq__cellLabel",
  "cellValue": "RiskSummaryWidget-module__zwk5Iq__cellValue",
  "grid": "RiskSummaryWidget-module__zwk5Iq__grid",
  "gridStack": "RiskSummaryWidget-module__zwk5Iq__gridStack",
});
